/* eslint-disable */
module.exports = {
  treeNodeActions({ node, uri }) {
    return [
      // {
      //   label: `Star ${node.id}`,
      //   icon: 'star',
      //   href: `/cgi-bin/imperia.pl?imp=/my/controller&${node.id}`,
      //   enabled: node.can_edit,
      // },
      // {
      //   label: `Customize ${node.id}`,
      //   icon: 'bolt',
      //   href: uri('/my/controller/', { id: node.id }),
      //   enabled: node.can_edit,
      // },
    ];
  },
};
